const baseSizes = {
    wideScreenBreakpoint: 1200,
    tabletBreakpoint: 1024,
    miniBreakpoint: 767,
    mobileBreakpoint: 550,
  } as const;
  
  export const styleSizesNumber = baseSizes;
  
  export const styleSizes = {
    wideScreenBreakpoint: `${baseSizes.wideScreenBreakpoint}px`,
    tabletBreakpoint: `${baseSizes.tabletBreakpoint}px`,
    miniBreakpoint: `${baseSizes.miniBreakpoint}px`,
    mobileBreakpoint: `${baseSizes.mobileBreakpoint}px`,
  } as const;